import Vue from 'vue';

import './styles/tailwind.scss';
import './styles/animations.scss';
import App from './App.vue';

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
